/**
 * ErrorBoundary: fängt React-Fehler in Kind-Komponenten ab, damit die Website
 * bei einem einzelnen fehlerhaften Feld nicht komplett weiß bleibt.
 */
import React from "react";
import { AlertTriangle, Home } from "lucide-react";
import { Link } from "react-router-dom";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    this.setState({ info });
    // Für Debugging in Konsole loggen
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-[60vh] flex items-center justify-center px-6" data-testid="error-boundary-fallback">
          <div className="max-w-lg text-center">
            <AlertTriangle className="w-10 h-10 text-brand-yellow mx-auto mb-3"/>
            <h1 className="font-heading text-2xl text-ink mb-2">Diese Seite konnte nicht vollständig geladen werden</h1>
            <p className="text-sm text-ink-muted mb-5">
              Es gab einen unerwarteten Fehler beim Laden. Bitte versuche es erneut oder gehe zurück zur Übersicht.
            </p>
            <div className="flex items-center justify-center gap-3">
              <button onClick={() => this.setState({ error: null, info: null })}
                className="text-sm px-4 py-2 rounded-md border border-hair hover:border-brand-yellow">
                Erneut versuchen
              </button>
              <Link to="/" className="btn-accent text-sm">
                <Home className="w-4 h-4"/> Zur Startseite
              </Link>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
